// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-grey[data-v-af4b82fe] {\n    color: #9e9e9e;\n    font-size: small;\n}\n", ""]);
// Exports
module.exports = exports;
